import {initiated, instantiate} from "./context/context";
import {log} from "./util/log";
import {CMPProxy} from "./cmp/cmp-proxy";
import cmpStatus from "./cmp-status";
import {__tcfapi, __tcfapiprivate} from "./api/api";
import {CMP_API, CMP_API_PRIVATE} from "./cmp/cmp";

export const init = () => {
    if (!initiated()) {
        log.debug('Initiating CMP...');

        const proxy: CMPProxy = new CMPProxy();
        instantiate(proxy);

        // Iniciamos el proxy
        proxy.load().then(() => {
            log.debug('CMP Proxy ready. Finishing load.');
            unstub();
            cmpStatus.finishLoad();
            if (proxy.consentAcquired) {
                cmpStatus.tcLoaded();
            }
        });

        log.debug('CMP initiated');
    }
}

const unstub = () => {
    // Comprobamos si hay un stub previo
    const stub: any = (window as any)[CMP_API];
    (window as any)[CMP_API] = __tcfapi;
    log.debug(`The API is ready`);

    const commandQueue = stub?.commandQueue??[];

    // Ejecutamos comandos encolados en el stub
    commandQueue.forEach((command: any) => {
        __tcfapi(command.name, command.version, command.callback, command.parameter);
    });

    // Comprobamos si hay un stub privado previo
    const stub_private: any = (window as any)[CMP_API_PRIVATE];
    (window as any)[CMP_API_PRIVATE] = __tcfapiprivate;
    log.debug(`The private API is ready`);
    let commandQueuePrivate: any[] = stub_private?.commandQueue??[];

    // Ejecutamos comandos encolados en el stub
    commandQueuePrivate.forEach((command: any) => {
        __tcfapiprivate(command.name, command.option, command.callback);
    });
}
